import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=40e66e66&scoped=true"
import script from "./activity-details.vue?vue&type=script&lang=js"
export * from "./activity-details.vue?vue&type=script&lang=js"
import style0 from "./activity-details.vue?vue&type=style&index=0&id=40e66e66&prod&lang=scss&scoped=true"
import style1 from "./activity-details.vue?vue&type=style&index=1&id=40e66e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e66e66",
  null
  
)

export default component.exports